<template>
  <ModalBase
    :show-modal="showInviteCustomerModal"
    @close-modal="close"
    :short="true"
    :narrow="true"
    :overlay-scrollb="true"
  >
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:title>
          <span v-translate>Invite Client</span>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <b-form @submit="onSubmit">
        <b-form-group id="input-group-1" :label="$gettext('Name:')" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="inviteCustomerForm.invite_to_name"
            type="text"
            :placeholder="$gettext('John Doe')"
            required
          />
        </b-form-group>
        <b-form-group
          id="input-group-2"
          :label="$gettext('Email address:')"
          label-for="input-2"
          :description="$gettext('The invite will be sent to this email.')"
        >
          <b-form-input
            id="input-2"
            v-model="inviteCustomerForm.invite_to"
            type="email"
            :placeholder="$gettext('john.doe@mycustomer.com')"
            required
          />
        </b-form-group>
        <b-form-group id="input-group-3" :label="$gettext('Personal message:')" label-for="input-3">
          <b-form-textarea
            id="input-3"
            v-model="inviteCustomerForm.message"
            rows="3"
            :placeholder="
              $gettext(
                'Online accounting for freelancers. Send professional invoices and use the Gekko mobile apps to track your hours, costs and trips.'
              )
            "
            required
          />
        </b-form-group>
      </b-form>
    </template>
    <template v-slot:actions>
      <GekkoButton
        @click="onSubmit()"
        :text="$gettext('Send Invitation')"
        class="pull-right position-relative"
        :loading="isWaitingForResponse"
      />
    </template>
  </ModalBase>
</template>

<script>
import GekkoButton from '@/components/GekkoButton'
import AccountantsService from '@/store/services/accountants.service'
import { mapGetters, mapMutations } from 'vuex'
import ModalBase from '@/components/base_components/ModalBase.vue'
import TitleBar from '@/components/TitleBar'

export default {
  name: 'IniviteCustomerModal',
  components: { GekkoButton, ModalBase, TitleBar },
  data() {
    return {
      showInviteCustomerModal: false,
      inviteCustomerForm: {
        invite_to_name: '',
        invite_to: '',
        message: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      isWaitingForResponse: 'main/isWaitingForResponse',
    }),
  },
  methods: {
    ...mapMutations({
      setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE',
    }),
    onSubmit() {
      this.inviteCustomerForm['company_profile'] = this.currentCompany.id
      this.inviteCustomerForm['accountant'] = this.currentCompany.accountant_branding.id
      if (this.isFormValid()) {
        this.setWaitingForResponse(true)
        AccountantsService.sendInvite(this.inviteCustomerForm)
          .then((response) => {
            this.$store.commit('setAlert', {
              title: this.$gettext('Success!'),
              text: this.$gettext('Invite sent to ') + response.data.invite_to_name + '.',
              variant: 'success',
              duration: 4,
            })
            this.$emit('invite-sent', false)
            this.close()
          })
          .catch((response) => {
            let msg = this.$gettext('An error occurred while sending the invite.')
            if ('non_field_errors' in response.data) {
              msg = this.$gettext('Invite already sent to this email address.')
            }

            this.$store.commit('setAlert', {
              title: this.$gettext('Error'),
              text: msg,
              variant: 'error',
              duration: 4,
            })
          })
          .finally(() => {
            this.setWaitingForResponse(false)
          })
      }
    },
    close() {
      this.resetForm()
      this.showInviteCustomerModal = false
    },
    resetForm() {
      this.inviteCustomerForm = {
        invite_to_name: '',
        invite_to: '',
        message: '',
      }
    },
    isFormValid() {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (!this.inviteCustomerForm.invite_to_name.length) {
        this.$store.commit('setAlert', {
          title: this.$gettext('Invalid Details'),
          text: this.$gettext('The name of the customer must be set.'),
          variant: 'error',
          duration: 4,
        })
        return false
      } else if (!this.inviteCustomerForm.invite_to.length) {
        this.$store.commit('setAlert', {
          title: this.$gettext('Invalid Details'),
          text: this.$gettext('The email of the customer must be set.'),
          variant: 'error',
          duration: 4,
        })
        return false
      } else if (!this.inviteCustomerForm.message.length) {
        this.$store.commit('setAlert', {
          title: this.$gettext('Invalid Details'),
          text: this.$gettext('Please, insert an invitation message.'),
          variant: 'error',
          duration: 4,
        })
        return false
      } else if (!re.test(this.inviteCustomerForm.invite_to)) {
        this.$store.commit('setAlert', {
          title: this.$gettext('Invalid Details'),
          text: this.$gettext('The email of the customer must be a valid address.'),
          variant: 'error',
          duration: 4,
        })
        return false
      }

      return true
    },
  },
}
</script>